<template>
<main-content>
    <kt-panel>
        <kt-panel-header>
            <kt-panel-header-toolbar class="w-100">
                <ul class="nav nav-pills" role="tablist">
                    <li class="nav-item">
                        <a :class="['nav-link', active_pane === '#user-info' ? 'active' : '']" data-toggle="tab" @click="gotoTab('#user-info')" href="#user-info" role="tab" aria-selected="false">
                            {{ $t('label.user-info') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a :class="['nav-link', active_pane === '#shaparak-info' ? 'active' : '']" data-toggle="tab" @click="gotoTab('#shaparak-info')" href="#shaparak-info" role="tab" aria-selected="false">
                            {{ $t('label.shaparak-info') }}
                        </a>
                    </li>
                    <li class="nav-item dropdown">
                        <a :class="['nav-link dropdown-toggle', (active_pane === '#new-ticket' || active_pane === '#tickets') ? 'active' : '']" data-toggle="dropdown" href="#" role="button" aria-haspopup="true">
                            {{ $t('label.support') }}
                        </a>
                        <div class="dropdown-menu dropdown-menu-right" x-placement="bottom-end">
                            <a class="dropdown-item" data-toggle="tab" @click="gotoTab('#new-ticket')" href="#new-ticket">{{ $t('label.new_ticket') }}</a>
                            <a class="dropdown-item" data-toggle="tab" @click="gotoTab('#tickets')" href="#tickets">{{ $t('label.tickets') }}</a>
                        </div>
                    </li>
                    <li class="nav-item dropdown">
                        <a :class="['nav-link dropdown-toggle', (active_pane === '#new-contract' || active_pane === '#contracts') ? 'active' : '']" data-toggle="dropdown" href="#" role="button" aria-haspopup="true">
                            {{ $t('label.contract_management') }}
                        </a>
                        <div class="dropdown-menu dropdown-menu-right" x-placement="bottom-end">
                            <a class="dropdown-item" data-toggle="tab" @click="gotoTab('#new-contract')" href="#new-contract">{{ $t('label.new_contract') }}</a>
                            <a class="dropdown-item" data-toggle="tab" @click="gotoTab('#contracts')" href="#contacts">{{ $t('label.contracts') }}</a>
                        </div>
                    </li>
                    <li class="nav-item dropdown">
                        <a :class="['nav-link dropdown-toggle', (active_pane === '#settlements' || active_pane === '#gateways' || active_pane === '#core_transactions' || active_pane === '#starshop_transactions' || active_pane === '#bank_accounts' || active_pane === '#wallets') ? 'active' : '']" data-toggle="dropdown" href="#" role="button" aria-haspopup="true">
                            {{ $t('label.financial') }}
                        </a>
                        <div class="dropdown-menu dropdown-menu-right" x-placement="bottom-end">
                            <a class="dropdown-item" data-toggle="tab" @click="gotoTab('#settlements')" href="#settlements">{{ $t('label.settlements') }}</a>
                            <a class="dropdown-item" data-toggle="tab" @click="gotoTab('#gateways')" href="#gateways">{{ $t('label.gateways') }}</a>
                            <a class="dropdown-item" data-toggle="tab" @click="gotoTab('#core_transactions')" href="#core_transactions">{{ $t('label.core-transactions') }}</a>
<!--                            <a class="dropdown-item" data-toggle="tab" href="#sheba-numbers">{{ $t('label.bank_accounts') }}</a>-->
                            <a class="dropdown-item" data-toggle="tab" @click="gotoTab('#bank_accounts')" href="#bank_accounts">{{ $t('label.bank_accounts') }}</a>
<!--                            <a class="dropdown-item" data-toggle="tab" @click="gotoTab('#wallets')" href="#wallets">{{ $t('label.wallet') }}</a>-->
                            <a class="dropdown-item" data-toggle="tab" @click="gotoTab('#pf_terminal_statistics')" href="#pf_terminal_statistics">{{ $t('label.pf_terminal_statistics') }}</a>
                            <a class="dropdown-item" data-toggle="tab" @click="gotoTab('#marketing')" href="#marketing">{{ $t('label.marketing_profit') }}</a>
                        </div>
                    </li>
                    <li
                        v-if="$can('change-access', 'user')"
                        class="nav-item"
                    >
                      <a :class="['nav-link', active_pane === '#permissions' ? 'active' : '']" data-toggle="tab" @click="gotoTab('#permissions')" href="#permissions" role="tab" aria-selected="false">
                        {{ $t('label.permissions') }}
                      </a>
                    </li>
                    <li>
                        <kt-button v-if="current_user.id !== user_hashid"
                                class="m-2" size="md" variant="success" type="button"
                                id="submit_access_change_btn" @click="LoginToUserPanel"
                        >
                            {{ $t('btn.LoginToUserPanel') }}
                        </kt-button>
                    </li>
                    <!-- <li class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#login-as" role="tab">
                            {{ $t('label.login_as') }}
                        </a>
                    </li> -->
                </ul>
                <div class="ml-auto">
                    <router-link
                        :to="`/users/${user_hashid}/pf-activities-logs`"
                        class="btn btn-outline-info"
                    >
                        {{ $t('label.show_pf_activity_log') }}
                    </router-link>
                </div>

            </kt-panel-header-toolbar>
        </kt-panel-header>
        <kt-panel-body>
            <div class="tab-content">
                <div :class="['tab-pane', active_pane === '#user-info' ? 'active' : '']" id="user_info">
                    <kt-row>
                        <kt-col xs="12" md="6">
                            <user-info v-if="user.user_type == user_types.REAL"></user-info>
                            <legal-user-info v-else></legal-user-info>
                        </kt-col>
                        <kt-col xs="12" md="6">
                            <user-statistics></user-statistics>
                            <user-profile></user-profile>
                        </kt-col>
                    </kt-row>
                </div>
                <div :class="['tab-pane', active_pane === '#shaparak-info' ? 'active' : '']">
                    <shaparak-info></shaparak-info>
                </div>
                <div :class="['tab-pane', (active_pane === '#new-ticket' || active_pane === '#tickets') ? 'active' : '']">
                    <tickets v-if="active_pane === '#tickets'"></tickets>
                    <new-ticket v-else-if="active_pane === '#new-ticket'"></new-ticket>
                </div>
                <div :class="['tab-pane', (active_pane === '#new-contract' || active_pane === '#contracts') ? 'active' : '']">
                    <contracts v-if="active_pane === '#contracts'"></contracts>
                    <NewContract v-else-if="active_pane === '#new-contract'"></NewContract>
                </div>
                <div :class="['tab-pane', (active_pane === '#settlements' || active_pane === '#gateways' || active_pane === '#core_transactions' || active_pane === '#starshop_transactions' || active_pane === '#bank_accounts' || active_pane === '#wallets' || active_pane === '#pf_terminal_statistics' || active_pane === '#marketing') ? 'active' : '']">
                    <settlements v-if="active_pane === '#settlements'"></settlements>
                    <gateways v-else-if="active_pane === '#gateways'"></gateways>
                    <core-transactions v-else-if="active_pane === '#core_transactions'"></core-transactions>
                    <bank-accounts v-else-if="active_pane === '#bank_accounts'"></bank-accounts>
<!--                    <user-wallet-list v-else-if="active_pane === '#wallets'" :user_hashid="user_hashid"></user-wallet-list>-->
                    <pf-terminal-statistics v-else-if="active_pane === '#pf_terminal_statistics'" :user_id="user_hashid"></pf-terminal-statistics>
                    <fetch-marketing v-else-if="active_pane === '#marketing'"></fetch-marketing>
                </div>
                <div v-if="user.access && current_user.permissions.length > 0" :class="['tab-pane', (active_pane === '#permissions' || active_pane === '#permissions') ? 'active' : '']">
                    <permissions
                        :user_roles="user.access.roles"
                        :user_permissions="user.access.permissions"
                    />
                </div>
                <!-- <div class="tab-pane" id="login-as">
                    <login-as></login-as>
                </div> -->
            </div>
            
        </kt-panel-body>
    </kt-panel>
</main-content>
</template>

<script>
import $ from 'jquery'
import { mapGetters } from 'vuex'
import mainContent from '@/components/main-content'
import userStatistics from './components/user-statistics'
import { getToken } from '@/common/jwt.service.js';
import { userTypes } from '@/constants/userTypes';

import {
    tickets,
    newTicket,
    userInfo,
    legalUserInfo,
    userProfile,
    settlements,
    shaparakInfo,
    bankAccounts,
    gateways,
    coreTransactions,
    fetchMarketing,
    loginAs,
}  from './components'
import UserWalletList from "@/views/wallets/AyandeWallets/Admin/components/user-wallet-details.vue";
import PfTerminalStatistics from "@/views/reports/components/Pf-Terminal-Statistics.vue";
import Contracts from "@/views/user/components/contracts.vue";
import NewContract from "@/views/user/components/new-contract.vue";
import Permissions from "@/views/user/components/permissions.vue";

export default {
    data() {
        return {
            active_pane: '#user-info',
            user_hashid: this.$route.params.hashid,
            user_types: userTypes,
        }
    },
    components: {
      Permissions,
        Contracts,
        NewContract,
        PfTerminalStatistics,
        UserWalletList,
        mainContent,
        tickets,
        newTicket,
        userInfo,
        legalUserInfo,
        userProfile,
        settlements,
        shaparakInfo,
        bankAccounts,
        gateways,
        coreTransactions,
        'user-statistics': userStatistics,
        fetchMarketing,
        // loginAs,
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.dispatch('user/fetchByHashId', vm.$route.params.hashid)
        })
    },
    mounted() {
        if (window.localStorage.getItem('secondPreviousRoutePath') === this.$router.history.current.path) {
            let tab = window.localStorage.getItem('user_details_active_tab');
            this.active_pane = (tab != null && tab != undefined) ? tab : '#user-info';
        }
    },
    methods: {
        gotoTab(selectedTab) {
            this.active_pane = selectedTab;
            window.localStorage.setItem('user_details_active_tab', selectedTab);
        },
        LoginToUserPanel() {
            let params = {
                'user_hashid': this.$route.params.hashid,
                'admin_hashid': this.current_user.id,
            }

            let token = getToken();
            window.localStorage.setItem('Admin_token', token);

            this.$store.dispatch('auth/adminLoginToUserPanel', params)
                .finally(() => {
                    if (this.authStatus === 'success') {
                        window.location.replace(this.$url(''));
                    } else {
                        alert('عملیات با خطا مواجه شد!')
                    }
                }
            )
        }
    },
    computed: {
        ...mapGetters('user', [
            'current_user',
            'user',
        ]),
        ...mapGetters('auth', [
            'authStatus',
        ])
    }
}
</script>

<style>
@media (min-width: 768px) {
    #user_info > div.row > :first-child {
        border-left: 1px solid #ddd;
    }
}
</style>
